import React from "react";

export default function PaperPlane({ color = "#ccc", ...restProps }) {
  return (
    <svg
      id="paper_plane"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1311.6 801.3"
      width="1311.6"
      height="801.3"
      {...restProps}
    >
      <g
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3px"
      >
        <path
          d="M785.6,272.6a2.1,2.1,0,0,0-2.1-.5L527.9,380.2a1.9,1.9,0,0,0-.1,3.4l79.3,37.5a1.8,1.8,0,0,0,1.6.1l49-20.7-20.8,48.9a1.8,1.8,0,0,0,.1,1.6l37.5,79.3a1.9,1.9,0,0,0,1.7,1.1h0a2,2,0,0,0,1.7-1.2L786,274.6A1.8,1.8,0,0,0,785.6,272.6Z"
        />
        <line className="cls-1" x1={715} y1="376.8" x2="675.2" y2="470.9" />
      </g>
    </svg>
  );
}
